import {Requests, defaultErrorHandler} from './base'
import ErrorMessage from '../../properties/errorMessage'


function authRequest ($parent) {

  $parent.isLoading = true

  let userName = $parent.userName
  let accessKeyID = $parent.accessKeyID

  const authConfig = {headers: {'Authorization': `${userName}-${accessKeyID}`}}

  Requests.get('/account', authConfig)
    .then(response => {

      $parent.$session.start()
      $parent.$session.set('userName', $parent.userName)
      $parent.$session.set('accessKeyID', $parent.accessKeyID)
      $parent.$session.set('user', response.data)

      $parent.$router.push('/scoring')
    })
    .catch(error => {
      return defaultErrorHandler(error, $parent)
    })
    .finally(() => {
      $parent.isLoading = false
    })
}


export {authRequest}



// WEBPACK FOOTER //
// ./src/modules/request/auth.js